<script setup>
import { computed } from 'vue';

const { row } = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const routerParams = computed(() => ({
  name: 'inbox_conversation',
  params: { conversation_id: row.original.conversationId },
}));
</script>

<template>
  <div>
    <router-link
      :to="routerParams"
      target="_blank"
      class="hover:underline text-woot-500 dark:text-woot-500"
    >
      {{ `#${row.original.conversationId}` }}
    </router-link>
  </div>
</template>
